import { Plugins} from '@capacitor/core';
import { FCM } from "capacitor-fcm";
import ApiService from "@/services/ApiService";
const { PushNotifications } = Plugins;
const fcm = new FCM();

export default {
    deviceToken: null,
    async pushInit() {
        try {
            PushNotifications.addListener('registrationError', (error) =>          {
                console.log(`error on register ${JSON.stringify(error)}`);
            });

            PushNotifications.addListener('pushNotificationReceived',
            (notification) => {
                console.log(`notification ${JSON.stringify(notification)}`);
            });

            PushNotifications.addListener('pushNotificationActionPerformed',
                async (notification) => {
                    console.log(notification);
                    // Do something
                });

            await PushNotifications.requestPermission();
            PushNotifications.register()
                .then(() => {
                    fcm
                        .getToken()
                        .then((r) => {
                            ApiService.getProfilApi().addDeviceToken(r.token);
                        })
                        .catch((err) => console.log(err));
                })
                .catch(() => {
                    //Si c'est android
                    PushNotifications.addListener('registration',
                        (token) => {
                            ApiService.getProfilApi().addDeviceToken(token.value);
                        }
                    );
                });
        } catch (e) {
            console.log(e);
        }
    }
}
